import request from '@/utils/request';


/**
 * 轮播图
 * @returns {Promise<*>}
 */
export async function getBannerList() {
  return request('/api/zeyin_school/app/bannerColumn/list');
}


/**
 * 模块列表
 * @param params
 * @returns {Promise<*>}
 */
export async function getHomeList(params) {
  return request('/api/zeyin_school/app/homeColumn/list', { params });
}


/**
 * 快捷入口
 * @param params
 * @returns {Promise<*>}
 */
export async function getQuickButtons(params) {
  return request('/api/zeyin_school/app/columnQuick/list', { params });
}


/**
 * 栏目分类
 * @param params
 * @returns {Promise<*>}
 */
export async function getCategoryList(params) {
  return request('/api/zeyin_school/app/columnCategory/list', { params });
}


/**
 * 最近更新
 * @param params
 * @returns {Promise<*>}
 */
export async function getLastUpdate(params) {
  return request('/api/zeyin_school/app/column/lastUpdateVideo', { params });
}


/**
 * 猜你喜欢
 * @param params
 * @returns {Promise<*>}
 */
export async function getLikeList(params) {
  return request('/api/zeyin_school/app/column/likeVideo', { params });
}


/**
 * 栏目详情
 * @param params
 * @returns {Promise<*>}
 */
export async function getDetail(params) {
  return request('/api/zeyin_school/app/column/detail', { params });
}


/**
 * 栏目剧集列表
 * @param params
 * @returns {Promise<*>}
 */
export async function getProgramVideos(params) {
  return request('/api/zeyin_school/app/column/columnVideoList', { params });
}



/**
 * 栏目剧集播放
 * @param params
 * @returns {Promise<*>}
 */
export async function setVideoPlay(params) {
  return request('/api/zeyin_school/app/column/columnVideoPlay', { params });
}

/**
 * 栏目剧集播放结束
 * @param params
 * @returns {Promise<*>}
 */
export async function setVideoPlayEnd(params) {
  return request('/api/zeyin_school/app/column/columnVideoPlayEnd', { params });
}


/**
 * 栏目评论列表
 * @param params
 * @returns {Promise<*>}
 */
export async function getProgramComments(params) {
  return request('/api/zeyin_school/app/column/columnCommentList', { params });
}

/**
 * 栏目评论详情
 * @param params
 * @returns {Promise<*>}
 */
export async function getProgramCommentDetail(params) {
  return request('/api/zeyin_school/app/column/columnCommentDetail', { params });
}


/**
 * 栏目评论
 * @param params
 * @returns {Promise<*>}
 */
export async function sendComment(params) {
  return request('/api/zeyin_school/app/column/comment', { params });
}


/**
 * 栏目评论删除
 * @param params
 * @returns {Promise<*>}
 */
export async function deleteComment(params) {
  return request('/api/zeyin_school/app/column/commentDelete', { params });
}


/**
 * 栏目评论点赞
 * @param params
 * @returns {Promise<*>}
 */
export async function likeComment(params) {
  return request('/api/zeyin_school/app/column/commentClickLike', { params });
}



/**
 * 栏目评论回复
 * @param params
 * @returns {Promise<*>}
 */
export async function sendReplyComment(params) {
  return request('/api/zeyin_school/app/column/commentReply', { params });
}



/**
 * 栏目评论回复删除
 * @param params
 * @returns {Promise<*>}
 */
export async function deleteReplyComment(params) {
  return request('/api/zeyin_school/app/column/commentReplyDelete', { params });
}



/**
 * 订阅栏目
 * @param params
 * @returns {Promise<*>}
 */
export async function subscriptionProgram(params) {
  return request('/api/zeyin_school/app/column/clickSubscription', { params });
}


/**
 * 收藏栏目
 * @param params
 * @returns {Promise<*>}
 */
export async function collectProgram(params) {
  return request('/api/zeyin_school/app/column/clickCollect', { params });
}


/**
 * 点赞栏目
 * @param params
 * @returns {Promise<*>}
 */
export async function likeProgram(params) {
  return request('/api/zeyin_school/app/column/clickLike', { params });
}

/**
 * 分享栏目
 * @param params
 * @returns {Promise<*>}
 */
export async function shareProgram(params) {
  return request('/api/zeyin_school/app/column/clickShare', { params });
}

/**
 * 收藏的栏目
 * @param params
 * @returns {Promise<*>}
 */
export async function myCollectProgram(params) {
  return request('/api/zeyin_school/app/memberColumn/columnCollectLog', { params });
}


/**
 * 浏览的栏目
 * @param params
 * @returns {Promise<*>}
 */
export async function myBrowseProgram(params) {
  return request('/api/zeyin_school/app/memberColumn/columnBrowseLog', { params });
}

/**
 * 订阅的栏目
 * @param params
 * @returns {Promise<*>}
 */
export async function mySubscriptionProgram(params) {
  return request('/api/zeyin_school/app/memberColumn/columnSubscriptionLog', { params });
}



/**
 * 栏目评论记录
 * @param params
 * @returns {Promise<*>}
 */
export async function programCommentLog(params) {
  return request('/api/zeyin_school/app/memberColumn/columnCommentLog', { params });
}


/**
 * 栏目评论回复我的记录
 * @param params
 * @returns {Promise<*>}
 */
export async function programCommentReplyLog(params) {
  return request('/api/zeyin_school/app/memberColumn/columnCommentReplyLog', { params });
}


/**
 * 栏目评论点赞我的记录
 * @param params
 * @returns {Promise<*>}
 */
export async function programCommentLikeLog(params) {
  return request('/api/zeyin_school/app/memberColumn/columnCommentLikeLog', { params });
}
